/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BridgeApiAttachment } from './BridgeApiAttachment';
import {
    BridgeApiAttachmentFromJSON,
    BridgeApiAttachmentFromJSONTyped,
    BridgeApiAttachmentToJSON,
    BridgeApiAttachmentToJSONTyped,
} from './BridgeApiAttachment';
import type { InternalApiAlertRfiMessageType } from './InternalApiAlertRfiMessageType';
import {
    InternalApiAlertRfiMessageTypeFromJSON,
    InternalApiAlertRfiMessageTypeFromJSONTyped,
    InternalApiAlertRfiMessageTypeToJSON,
    InternalApiAlertRfiMessageTypeToJSONTyped,
} from './InternalApiAlertRfiMessageType';

/**
 * Alert RFI Message
 * @export
 * @interface InternalApiAlertRfiMessage
 */
export interface InternalApiAlertRfiMessage {
    /**
     * 
     * @type {string}
     * @memberof InternalApiAlertRfiMessage
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiAlertRfiMessage
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiAlertRfiMessage
     */
    createdByUserName?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiAlertRfiMessage
     */
    createdByOrganisationName?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiAlertRfiMessage
     */
    conversationId: string;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiAlertRfiMessage
     */
    creationDate: Date;
    /**
     * 
     * @type {Array<BridgeApiAttachment>}
     * @memberof InternalApiAlertRfiMessage
     */
    attachments?: Array<BridgeApiAttachment>;
    /**
     * 
     * @type {InternalApiAlertRfiMessageType}
     * @memberof InternalApiAlertRfiMessage
     */
    type: InternalApiAlertRfiMessageType;
}



/**
 * Check if a given object implements the InternalApiAlertRfiMessage interface.
 */
export function instanceOfInternalApiAlertRfiMessage(value: object): value is InternalApiAlertRfiMessage {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('conversationId' in value) || value['conversationId'] === undefined) return false;
    if (!('creationDate' in value) || value['creationDate'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function InternalApiAlertRfiMessageFromJSON(json: any): InternalApiAlertRfiMessage {
    return InternalApiAlertRfiMessageFromJSONTyped(json, false);
}

export function InternalApiAlertRfiMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiAlertRfiMessage {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'content': json['content'],
        'createdByUserName': json['createdByUserName'] == null ? undefined : json['createdByUserName'],
        'createdByOrganisationName': json['createdByOrganisationName'] == null ? undefined : json['createdByOrganisationName'],
        'conversationId': json['conversationId'],
        'creationDate': (new Date(json['creationDate'])),
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(BridgeApiAttachmentFromJSON)),
        'type': InternalApiAlertRfiMessageTypeFromJSON(json['type']),
    };
}

export function InternalApiAlertRfiMessageToJSON(json: any): InternalApiAlertRfiMessage {
    return InternalApiAlertRfiMessageToJSONTyped(json, false);
}

export function InternalApiAlertRfiMessageToJSONTyped(value?: InternalApiAlertRfiMessage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'content': value['content'],
        'createdByUserName': value['createdByUserName'],
        'createdByOrganisationName': value['createdByOrganisationName'],
        'conversationId': value['conversationId'],
        'creationDate': value['creationDate'].toISOString(),
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(BridgeApiAttachmentToJSON)),
        'type': InternalApiAlertRfiMessageTypeToJSON(value['type']),
    };
}

